import { getInfCLogger } from '@infodata-group/inf-commons-core';

const logger = getInfCLogger('LogFunctionDecorator');

export function logFunctionDecorator() {
  return function (
    target: any,
    propertyKey: string,
    description: PropertyDescriptor,
  ) {
    logger.debug(
      `Calling function: ${propertyKey} of class: ${target.constructor.name}`,
      description,
    );
  };
}
